import { isSameDay } from 'date-fns';
import getEndOfDayDate from './getEndOfDayDate';
export default function getRangeValue(_ref) {
  let {
    newlySelectedDate,
    startDate,
    endDate,
    allowSameStartAndEndDate
  } = _ref;
  if (startDate && endDate) {
    return {
      startDate: newlySelectedDate,
      endDate: null
    };
  } else if (!startDate) {
    return {
      startDate: newlySelectedDate,
      endDate: null
    };
  } else if (startDate > newlySelectedDate) {
    const newEndDate = getEndOfDayDate(startDate);
    return {
      startDate: newlySelectedDate,
      endDate: newEndDate
    };
  } else if (isSameDay(startDate, newlySelectedDate)) {
    if (allowSameStartAndEndDate) {
      const newEndDate = getEndOfDayDate(newlySelectedDate);
      return {
        startDate,
        endDate: newEndDate
      };
    } else {
      return {
        startDate: newlySelectedDate,
        endDate: null
      };
    }
  } else {
    const newEndDate = getEndOfDayDate(newlySelectedDate);
    return {
      startDate,
      endDate: newEndDate
    };
  }
}
//# sourceMappingURL=getRangeValue.js.map